import { Divider, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useVatDeclarationsDefinePeriodPayoutModal } from '../../context/vatDeclarationsDefinePayoutModalContext'
import { DefinePayoutDetails } from './elements/DefinePayoutDetails'
import { DefinePayoutForm } from './elements/DefinePayoutForm'

export const ModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const { Form } = useVatDeclarationsDefinePeriodPayoutModal()

  return (
    <Form>
      <Text variant="bodyLG">{t('vat_declarations.define_payout_modal.intro')}</Text>
      <Space size="s12" />
      <DefinePayoutForm />
      <Space size="s12" />
      <Divider />
      <Space size="s12" />
      <DefinePayoutDetails />
    </Form>
  )
}
